export default "__VITE_ASSET__DxA7zyTn__"